/**
 * Intentionally minimal placeholder for the locale home route.
 *
 * Do not use a full-page shimmer here: the homepage is the main entry and
 * animated skeletons feel noisy. Other segments keep rich skeletons via their
 * own `loading.tsx` files (about, properties, etc.).
 *
 * If this component is ever wired to a route loading boundary, users see a
 * calm blank shell only — not a distracting mock layout.
 */
export function AllysHomeSkeleton() {
  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: 'var(--color-background, #FFFFFF)' }}
      aria-hidden
    />
  );
}
